<template>
    <div class="gallery-slider">
        <LightBox ref="lightbox" :media="images" :showLightBox="false"></LightBox>
<!--        Todo: Swiper has been substituted with apprentice-swiper,
                  check swiperOption and add them if needed to the component ass props. -->

<!--        <swiper class="swiper lp-category-swiper"-->
<!--                :options="swiperOption">-->
<!--            <swiper-slide v-for="(image, index) of galleryIn"-->
<!--                          :key="image.id">-->
<!--                <img :src="image.path" :alt="image.title" @click="onImageClick(index)">-->
<!--            </swiper-slide>-->
<!--            <div class="swiper-pagination" slot="pagination"></div>-->
<!--            <div class="swiper-button-prev" slot="button-prev"></div>-->
<!--            <div class="swiper-button-next" slot="button-next"></div>-->
<!--        </swiper>-->
    </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
// import 'swiper/swiper-bundle.css'
import LightBox from 'vue-image-lightbox';
require('vue-image-lightbox/dist/vue-image-lightbox.min.css');

export default {
    name: "design-2021-learning-path-category-show-gallery-slider-component",
    props: {
        galleryIn: {
            type: Array,
            required: true,
        }
    },
    components: {
        Swiper,
        SwiperSlide,
        LightBox,
    },
    data() {
        return {
            swiperOption: {
                effect: 'coverflow',
                grabCursor: true,
                centeredSlides: true,
                slidesPerView: 'auto',
                coverflowEffect: {
                    rotate: 50,
                    stretch: 0,
                    depth: 100,
                    modifier: 1,
                    slideShadows : true
                },
                loop: true,
                loopFillGroupWithBlank: false,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
            },
            images: this.galleryIn.map(gallery => {
                return {
                    thumb: gallery.path,
                    src: gallery.path,
                    caption: gallery.title,
                }
            })
        }
    },
    methods: {
        onImageClick(index) {
            this.$refs.lightbox.showImage(index);
        },
    }
}
</script>

<style scoped lang="scss">
.swiper {
    .swiper-slide ::v-deep {
        width: 300px !important;
        height: 255px !important;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            object-position: center;
        }

        &,
        img,
        .swiper-slide-shadow-left,
        .swiper-slide-shadow-right {
            border-radius: 12px;
        }
    }

    .swiper-button-next,
    .swiper-button-prev {
        background-color: $white;
        border-radius: 50%;
        padding: map-get($grid-gutter-spacing, 'eight');
        border: 1px solid $primary;
        height: 21px;
        width: 21px;

        &:after {
            font-family: 'Font Awesome 5 Pro';
            font-size: $base-font-size;
            color: $primary;
        }
    }

    .swiper-button-prev {
        &:after {
            content: '\f053';
        }
    }

    .swiper-button-next {
        &:after {
            content:'\f054';
        }
    }


    .swiper-pagination {
        ::v-deep .swiper-pagination-bullet.swiper-pagination-bullet-active {
            background-color: $white;
            border: 1px solid $primary;
        }
    }
}
</style>
